import React, { useState, useEffect, useRef, useCallback, useMemo, memo } from 'react';
import { useSelector } from 'react-redux';
import CustomKeyboard from "@components/common/CustomKeyboardCopy/indexRevamp"
import { flowType } from '../../../utility/userInfo';
import { getObjectValue } from '@utility/utills';
import { ReactComponent as Cross } from '@assets/images/cross.svg';
import { ReactComponent as SearchIcon } from '@assets/images/Searchfield.svg';
import 'react-simple-keyboard/build/css/index.css';
import Styles from './search.module.scss';
import cn from 'classnames';
import { TouchableDiv } from '@components/common/Touchable'

const Search = ({
  isSearch,
  orderSearch,
  onChange,
  onClose,
  isTop,
  isOrderScreen,
  customStyle,
  placeholderName,
  browserOrtablet,
  setOpenKeyboard,
  openKeyboard,
  serverAppTheme,
  checkList
}) => {
  const deviceInfo = useSelector(state => state.oauth.deviceInformation);

  const [touchState, setTouchState] = useState({ xDown: null, yDown: null });
  const [swipedDown, setSwipedDown] = useState(false);
  const [searchString, setSearchString] = useState('');

  const ref = useRef(null);
  const keyboard = useRef(null);
const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;
  
  const serverAppThemeNumber = useMemo(() => 
    getObjectValue(() => JSON.parse(window.sessionStorage.getItem('auth')).serverAppTheme, 1),
    []
  );
  
  const isServerApp = useMemo(() => flowType() === 'serverApp', []);
  const isCallCenter = useMemo(() => 
    getObjectValue(() => isServerApp && [2].includes(deviceInfo?.deviceGroup?.startMode), false),
    [isServerApp, deviceInfo]
  );
  const isPaymentApp = useMemo(() => flowType() === 'paymentTerminal', []);

  const handleClickOutside = useCallback((event) => {
    if (ref.current && !ref.current.contains(event.target) && !keyboard.current?.input?.default) {
      setSearchString('');
      setSwipedDown(false);
      onClose();
      setOpenKeyboard(false);
    }
  }, [onClose]);

  const closeKeyboard = useCallback(() => {
    setSearchString('');
    onChangeRef.current('');
    onCloseRef.current();
  }, []);

  const handleBlur = useCallback(() => {
    setSwipedDown(false);
    const element = document.querySelector('#search');
    if (element) element.blur();
  }, []);

  const browserMode = useCallback((data) => {
    setSearchString();
    setOpenKeyboard(data.board);
  }, [setOpenKeyboard]);

  const tabletMode = useCallback((data) => {
    setOpenKeyboard(data.board);
    handleBlur();
  }, [setOpenKeyboard, handleBlur]);

  const onClickBtn = useCallback((value) => {
    setSearchString(prev => {
      const newValue = value === '{bksp}' ? prev.slice(0, -1) : prev.concat(value);
      onChangeRef.current(newValue);
      return newValue;
    });
  }, []);

  const getTouches = (evt) => evt.touches || evt.originalEvent.touches;

  const handleTouchStart = useCallback((evt) => {
    const firstTouch = getTouches(evt)[0];
    setTouchState({
      xDown: firstTouch.clientX,
      yDown: firstTouch.clientY
    });
  }, []);

  const handleTouchMove = useCallback((evt) => {
    evt.preventDefault();
    const { xDown, yDown } = touchState;

    if (!xDown || !yDown) return;  // just return, no value

    const xUp = evt.touches[0].clientX;
    const yUp = evt.touches[0].clientY;
    const xDiff = xDown - xUp;
    const yDiff = yDown - yUp;

    if (Math.abs(xDiff) <= Math.abs(yDiff)) {
      setSwipedDown(yDiff <= 0);
    }

    setTouchState({ xDown: null, yDown: null });
  }, [touchState]);

  useEffect(() => {
    if (!orderSearch) {
      document.addEventListener('click', handleClickOutside, true);
      return () => {
        document.removeEventListener('click', handleClickOutside, true);
      };
    }
  }, [handleClickOutside]);

  useEffect(() => {
    if (!swipedDown && keyboard.current) {
      keyboard.current.input.default = searchString || '';
    }
  }, [swipedDown, searchString]);

  const searchInput = useMemo(() => (
    <input
      id="search"
      type="text"
      className={cn(
        'form-control fs_16 py-1 position-relative rounded w-100',
        !checkList && 'pr-4',
        Styles.myTheme_text_color,
        Styles.keyboredBackground,
        isCallCenter && Styles.autofocus_input,
        isCallCenter && Styles.no_pointer,
        checkList && 'border-0',
        orderSearch && Styles.orderSearchBox
      )}
      placeholder={placeholderName || "Search table or check dd"}
      onChange={(e) => { 
        const value = e.target.value;
        setSearchString(value); 
        onChange(value); 
      }}
      aria-label="Search"
      aria-labelledby="searchbtn"
      title="search"
      value={searchString}
      style={{
        background: serverAppTheme?.check_search_field_bg,
        color: serverAppTheme?.primary_text,
        // height: '44px',
        // paddingLeft: orderSearch ? '4rem' : checkList ? '2.5rem'  : '',
        height: orderSearch ? '44px' : '32px',
        paddingLeft: orderSearch ? '4rem' : checkList ? '2rem'  : '',
        paddingRight: checkList && '1.8rem'
      }}
      onFocus={() => {
        browserOrtablet 
          ? browserMode({ board: false })
          : tabletMode({ board: true });
      }}
      autoFocus={orderSearch || isCallCenter}
    />
  ), [
    checkList, placeholderName, onChange, serverAppTheme, 
    isCallCenter, searchString, browserOrtablet, browserMode, tabletMode
  ]);

  const keyboardComponent = useMemo(() => {
    if (!orderSearch && !(openKeyboard && (isServerApp || isPaymentApp) && !swipedDown && !isCallCenter)) {
      return null;
    }
    
    return (
      <div className={cn('w-100 border-0', Styles.keyboardBorder)}>
        {/* {checkList &&
        <div>
          <div
              role="presentation"
              className={cn("position-absolute fs_15 pr-3", serverAppThemeNumber === 2 ? "color-black" : '')}
              style={{left: '1%', zIndex: '999', top: '7%', transform: 'translateY(-50%)'}}
            >
              <SearchIcon 
                role="presentation" 
                height={20} 
                width={20} 
                fill={serverAppTheme?.iconcolor} 
                aria-hidden="true" 
              />
            </div>
            <div>{searchInput}</div>
          
          {searchString.length > 0 &&
          <TouchableDiv
            role="presentation"
            className={cn("position-absolute fs-14", serverAppThemeNumber === 2 && "color-black")}
            style={
             
                  {right: '0', top: '6%', transform: 'translateY(-50%)' }
            }
            onClick={() => {
              setSearchString('');
              onChange('');
              setSwipedDown(false);
            }}
          >
            <Cross fill={serverAppTheme?.iconcolor} aria-hidden="true" height="20px" />
          </TouchableDiv>}
        </div>} */}
        
        <CustomKeyboard
          onClickBtn={onClickBtn}
          type="textDefaultCaps"
          customClass="h-auto mt-auto p-2"
          btnSize="btn35"
          orderSearch={orderSearch || false}
          closeKeyboard={closeKeyboard}
        />
      </div>
    );
  }, [openKeyboard, isServerApp, isPaymentApp, swipedDown, isCallCenter, orderSearch]);

  if (!isSearch && !orderSearch) return <div className="d-none" />;

  return (
    <div ref={ref} className={cn(orderSearch ? '' : "col-12 px-0")}>
      <div className={cn('col-12 px-0', isTop && Styles.checkScreenSearchBox)}>
        {checkList && (
          <div>
            <div
              role="presentation"
              className={cn("position-absolute fs_15", serverAppThemeNumber === 2 && "color-black")}
              style={{left: '3%', zIndex: '999', top: '50%', transform: 'translateY(-50%)'}}
            >
              <SearchIcon 
                role="presentation" 
                height={20} 
                width={20} 
                // height={32} 
                // width={30} 
                fill={serverAppTheme?.iconcolor} 
                aria-hidden="true" 
              />
            </div>
          </div>
        )}
        
        {/* {!checkList && {searchInput}} */}
        {searchInput}
        {((orderSearch && searchString.length > 0) || !orderSearch) && (
          <TouchableDiv
            role="presentation"
            className={cn("position-absolute fs-14", serverAppThemeNumber === 2 && "color-black")}
            style={
              isOrderScreen
                ? { left: '23%', top: '25%', transform: 'translateY(-50%)' }
                : customStyle
                  ? customStyle
                  : { right: '3%', top: '53%', transform: 'translateY(-50%)' }
            }
            onClick={(e) => {
              setSearchString('');
              onChange('');
              !orderSearch && onClose();
              setSwipedDown(false);            
              e.preventDefault();
            }}
          >
            <Cross fill={serverAppTheme?.iconcolor} aria-hidden="true" height="20px" />
          </TouchableDiv>
        )}
      </div>
      
      {openKeyboard && (
        <div 
          className={cn(
            'd-flex flex-column justify-content-end align-items-end',
            swipedDown && !orderSearch ? 'col-4 p-0 offset-8' : '',
            isPaymentApp ? Styles.myThemePayApp : orderSearch ? Styles.orderTheme : Styles.myTheme1
          )} 
          onTouchMove={handleTouchMove} 
          onTouchStart={handleTouchStart} 
          role="alert"
        >
          {keyboardComponent}
        </div>
      )}
    </div>
  );
};

export default memo(Search);

